import React, { useState, useEffect, useMemo } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import Navigation from './Navigation/Navigation';
import Common from './Common/Common';
import { getApplications2ById } from '../../utils/http';
import { routes } from '../../utils/routes';
import './ApplicationStep2.css';
import ProjectInfo from './Common/ProjectInfo/ProjectInfo';
import Step from './Common/Step/Step';


function ApplicationStep2({ history }) {
  const [loading, setLoading] = useState(true);
  const [application, setApplication] = useState(null);
  const [view, setView] = useState('common');
  const onChangeView = (newView) => setView(newView);

  useEffect(() => {
    const id = history.location.pathname.split('/')[2];
    getApplications2ById(id)
      .then((resp) => {
        setLoading(false);
        setApplication(resp);
      });
  }, []);

  const onRedirectToList = () => history.push(routes.homePage);

  const tabs = useMemo(() => {
    const list = [];

    list.push({
      value: 'common',
      label: 'Общая информация',
      content: <Common applicationProp={application} onRedirectToList={onRedirectToList} />,
    });

    if (application?.status === 'Поддержана' || application?.isEditable) {
      list.push({
        value: 'project',
        label: 'Информация о проекте',
        content: <ProjectInfo applicationProp={application} onRedirectToList={onRedirectToList} />,
      });
    }

    // if (application?.steps > 0) {
    //   for (let i = 0; i <= application.steps; i += 1) {
    //     list.push({
    //       value: `step${i + 1}`,
    //       label: `Этап ${i + 1}`,
    //       content: <Step />,
    //     });
    //   }
    // }

    return list;
  }, [application]);

  useEffect(() => {
    if (tabs.length > 1) {
      setView('project');
    }
  }, [tabs]);

  return (
    <div className="applicationStep2-wrapper">
      {application && (
        <Navigation
          view={view}
          tabs={tabs}
          application={application}
          onChangeView={onChangeView}
          onAddStep={() => {}}
          hasAddStep={false}
        />
      )}
      {loading && <Spin indicator={<LoadingOutlined style={{ fontSize: 100, zIndex: 100 }} spin />} style={{ position: 'absolute', top: '40%', left: '40%' }} />}
      {tabs.map((tab) => (view === tab.value && application && tab.content))}
      {/* {view === 'common' && application && <Common applicationProp={application} onRedirectToList={onRedirectToList} />}
      {view === 'project' && application && <ProjectInfo applicationProp={application} onRedirectToList={onRedirectToList} />} */}
    </div>
  );
}

ApplicationStep2.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default withRouter(ApplicationStep2);
